import { ONE_DECIMAL_OPTION } from "@/hooks/useConfig/numberAbbreviatorOptions";
import { colors } from "@/Utils";
import { Theme } from "@mui/material";
import { TooltipComponentOption } from "echarts";

/**
 * Helper function to render a metric row with label and value
 */
const renderMetricRow = (label: string, value: string, theme: Theme) => `
  <div style="display: flex; gap: 8px; align-items: center; font-size: 14px; line-height: 1;">
    <span style="
      color: ${theme.palette.text.primary};
      font-family: 'Montserrat', sans-serif;
      font-weight: 400;
      letter-spacing: 0.4px;
      opacity: 0.9;
    ">
      ${label}:
    </span>
    <span style="
      color: ${theme.palette.text.primary};
      font-family: 'Roboto', sans-serif;
      font-weight: 400;
      letter-spacing: 0.25px;
      ">
      ${value}
    </span>
  </div>
`;

/**
 * Creates the tooltip configuration for the bubble chart
 */
export const getBubbleChartTooltip = (
  theme: Theme,
  numberFormatter: (value: number, options?: any) => string
): TooltipComponentOption => {
  return {
    trigger: "item",
    padding: 0,
    borderColor: colors.white,
    formatter: (param: any) => {
      if (!param || !param.value) return "";

      const [confidenceInterval = 0, changeFromHistoricSpend = 0] = param.value;
      const channelName = param.name;

      const formattedConfidenceInterval = numberFormatter(confidenceInterval, ONE_DECIMAL_OPTION);
      const formattedSpendChange = `${changeFromHistoricSpend.toFixed(0)}%`;

      return `
        <div style="
          padding: 20px;
          border-radius: 4px;
          box-shadow: -4px 4px 16px 0px rgba(0, 0, 0, 0.1);
          display: flex;
          flex-direction: column;
          gap: 12px;
          width: 280px;
        ">
          <div style="display: flex; align-items: center">
            <span style="
              color: ${theme.palette.text.primary};
              font-family: 'Montserrat', sans-serif;
              font-size: 16px;
              font-weight: 600;
              line-height: 1;
              letter-spacing: 0.1px;
            ">
              ${channelName}
            </span>
          </div>

          ${renderMetricRow("Size of Confidence Interval", formattedConfidenceInterval, theme)}
          ${renderMetricRow("Change in Historic Spend", formattedSpendChange, theme)}
        </div>
      `;
    },
  };
};
